import { TodoCompletion } from '../components/TodoCompletion';
import { SearchTodo } from '../components/SearchTodo';
import { TodoList } from '../components/TodoList';
import { CreateTodoButton } from '../components/CreateTodoButton';
import { TodoItem } from '../components/TodoItem';
import { AppHeader } from '../components/AppHeader';
import { TodosLoading } from '../components/TodosLoading';
import { TodosError } from '../components/TodosError';
import { TodosEmpty } from '../components/TodosEmpty';
import { TodoContext } from '../TodoContext';
import { useContext } from 'react';
import { Modal } from '../components/Modal';
import { TodoForm } from '../components/TodoForm';


export function AppUI() {
  const {
    loading, error,
    filteredTodos,
    handleComplete, handleDelete,
    openModal
  } = useContext(TodoContext);
  return (
    <>
      <AppHeader />

      <TodoCompletion />

      <SearchTodo />

      <CreateTodoButton />

      <TodoList>
        {loading && <TodosLoading />}
        {error && <TodosError />}
        {!loading && filteredTodos.length === 0 && <TodosEmpty />}
        {filteredTodos.map(
          todo =>
            <TodoItem
              key={todo.id}
              id={todo.id}
              todoText={todo.text}
              completed={todo.completed}
              onComplete={() => handleComplete(todo.id)}
              onDelete={() => handleDelete(todo.id)}
            />
        )}
      </TodoList>

      {openModal && (
        <Modal>
          <TodoForm />
        </Modal>
      )}
    </>
  )
}